import * as tokens from '../../../tokens/typography.generated.js';
// Component (Cmp) typography mapping.
// Structure mirrors semantic path: cmp.typography.ui.productCard.headline
// Exposes: typographyTokenMapping.cmp.typography.ui.productCard.headline
// The value is a typography token object (or an alias referencing a system token).
export const componentTypography = {
    typography: {
        ui: {
            productCard: {
                headline: tokens.CMP_TYPOGRAPHY_UI_PRODUCT_CARD_HEADLINE
            }
        }
    }
};
//# sourceMappingURL=component.js.map